// extracted by mini-css-extract-plugin
export var animationContainer = "_fc-0";
export var asteriskIcon = "_fc-8";
export var conversationLeftSection = "_fc-4";
export var conversationListItem = "_fc-3";
export var conversationMiddleSection = "_fc-5";
export var conversationRightSection = "_fc-6";
export var detailsContent = "_fc-1";
export var listContainer = "_fc-7";
export var modalContent = "_fc-2";